/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_BuscadorPersona as BuscadorPersona,
  rec_EstadoError as EstadoError,
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_Modal as Modal,
  rec_PO as PO,
  rec_React as React,
  rec_SelectorFecha as SelectorFecha,
  rec_SelectorMultiple as SelectorMultiple,
  rec_Vo as Vo,
  rec_api as api,
  rec_ra as ra,
} from "../../runtime/index.jsx";
export function FormularioEstrategia({
  unidadId: e,
  estrategia: t,
  onClose: n,
  onGuardado: r,
}) {
  let i = !!t,
    [a, o] = (0, React.useState)(() => ({
      nombre: t?.nombre ?? ``,
      descripcion: t?.descripcion ?? ``,
      responsable: t?.responsableId
        ? {
            id: t.responsableId,
            nombre: t.responsableNombre,
          }
        : null,
      fechaInicio: t?.fechaInicio ?? ``,
      fechaMeta: t?.fechaMeta ?? ``,
      estado: t?.estado ?? `EN_CURSO`,
    })),
    [s, c] = (0, React.useState)(``),
    l = (e) => (t) =>
      o((n) => ({
        ...n,
        [e]: t,
      }));
  async function u() {
    if ((c(``), !a.nombre.trim())) {
      c(`Ponle un nombre a la estrategia.`);
      return;
    }
    let n = {
      unidadId: e,
      nombre: a.nombre,
      descripcion: a.descripcion,
      responsableId: a.responsable?.id ?? null,
      fechaInicio: a.fechaInicio || null,
      fechaMeta: a.fechaMeta || null,
      ...(i
        ? {
            estado: a.estado,
            version: t?.version,
          }
        : {}),
    };
    try {
      r(
        i
          ? await api(`/estrategias/${t.id}`, {
              method: `PUT`,
              body: n,
            })
          : await api(`/estrategias`, {
              method: `POST`,
              body: n,
            }),
      );
    } catch (e) {
      c(e.message);
    }
  }
  return (
    <Modal
      titulo={i ? `Editar estrategia` : `Nueva estrategia`}
      onClose={n}
      children={
        <div
          className={`flex flex-col gap-3`}
          children={[
            <label
              className={`flex flex-col gap-1 text-sm text-(--text-h)`}
              children={[
                `Nombre`,
                <input
                  className={Lo}
                  value={a.nombre}
                  onChange={(e) => l(`nombre`)(e.target.value)}
                  maxLength={200}
                  placeholder={`Ej.: Retener talento en el primer año`}
                />,
              ]}
            />,
            <label
              className={`flex flex-col gap-1 text-sm text-(--text-h)`}
              children={[
                `Descripción `,
                <span
                  className={`text-xs text-(--text)`}
                  children={`(opcional)`}
                />,
                <textarea
                  className={`${Lo} min-h-20`}
                  value={a.descripcion}
                  onChange={(e) => l(`descripcion`)(e.target.value)}
                  maxLength={2e3}
                  placeholder={`Qué se quiere lograr y cómo se va a notar`}
                />,
              ]}
            />,
            <div
              className={`flex flex-col gap-1 text-sm text-(--text-h)`}
              children={[
                `Responsable`,
                a.responsable ? (
                  <div
                    className={`flex items-center gap-2 rounded-xl border border-(--border) px-3 py-2`}
                    children={[
                      <span
                        className={`min-w-0 flex-1 truncate`}
                        children={a.responsable.nombre}
                      />,
                      <button
                        type={`button`}
                        onClick={() => l(`responsable`)(null)}
                        aria-label={`Quitar responsable`}
                        className={`rounded-lg p-1.5 text-(--text) hover:bg-(--accent-bg) ${Vo}`}
                        children={(0, JSXRuntime.jsx)(ra, {
                          className: `h-4 w-4`,
                        })}
                      />,
                    ]}
                  />
                ) : (
                  <BuscadorPersona
                    onSelect={(e) => l(`responsable`)(e)}
                    placeholder={`Buscar persona…`}
                  />
                ),
              ]}
            />,
            <div
              className={`grid grid-cols-1 gap-3 sm:grid-cols-2`}
              children={[
                <label
                  className={`flex flex-col gap-1 text-sm text-(--text-h)`}
                  children={[
                    `Inicio`,
                    <SelectorFecha
                      value={a.fechaInicio}
                      onChange={l(`fechaInicio`)}
                      max={a.fechaMeta || void 0}
                    />,
                  ]}
                />,
                <label
                  className={`flex flex-col gap-1 text-sm text-(--text-h)`}
                  children={[
                    `Fecha meta`,
                    <SelectorFecha
                      value={a.fechaMeta}
                      onChange={l(`fechaMeta`)}
                      min={a.fechaInicio || void 0}
                    />,
                  ]}
                />,
              ]}
            />,
            i && (
              <div
                className={`flex flex-col gap-1 text-sm text-(--text-h)`}
                children={[
                  `Estado`,
                  <SelectorMultiple
                    value={a.estado}
                    onChange={l(`estado`)}
                    opciones={PO.map(({ value: e, label: t }) => ({
                      value: e,
                      label: t,
                    }))}
                  />,
                  a.estado === `CANCELADA` && t?.estado !== `CANCELADA` && (
                    <p
                      className={`text-xs text-(--text)`}
                      children={`Queda en la lista como cancelada y ya no recibe proyectos.`}
                    />
                  ),
                ]}
              />
            ),
            <EstadoError mensaje={s} />,
            <div
              className={`flex justify-end gap-2 pt-1`}
              children={[
                <AccionAsync
                  variante={`secundario`}
                  onClick={n}
                  children={`Cancelar`}
                />,
                <AccionAsync
                  onClick={u}
                  textoOcupado={`Guardando…`}
                  children={i ? `Guardar` : `Crear estrategia`}
                />,
              ]}
            />,
          ]}
        />
      }
    />
  );
}
